import { render, staticRenderFns } from "./TypeChart.vue?vue&type=template&id=e53f50fa&"
import script from "./TypeChart.vue?vue&type=script&lang=js&"
export * from "./TypeChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports